import {Component, EventEmitter, Injectable, Input, Output} from '@angular/core';
import {NgbModal, NgbActiveModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Observable, Subject} from "rxjs";
import {BaseFormGroup} from "../../models/form";

export interface BaseModalModel {
	title: string;
}

@Component({
	selector: 'base-modal',
	template: `
		<div class="modal-header">
			<h4 class="modal-title">{{title}}</h4>
			<button
				type="button"
				class="close"
				aria-label="Close"
				(click)="close()"
				[sextant]="'cancelBaseModal'"
			>
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<ng-content></ng-content>
			
			<loading [isLoad]="isLoading"></loading>
			
			<div class="alert alert-danger" *ngIf="form?.sendFormError">
				{{ form?.sendFormError.message }}
			</div>
		</div>
		<div class="modal-footer">
			<button
				type="button"
				class="btn btn-default"
				(click)="close()"
				*ngIf="btnCloseDisplay"
				[sextant]="'cancelBaseModal'"
			>Отмена</button>
			
			<button
				type="button"
				class="btn"
				[ngClass]="btnOkClass"
				[disabled]="!isBtnOkActive"
				(click)="ok()"
				#btnOk
				[sextant]="'okBaseModal'"
			>{{btnOkLabel}}</button>
		</div>`
})
export class BaseModalComponent implements BaseModalModel {
	@Input() title: string = '';
	
	@Input() btnOkLabel: string = 'Ok';
	@Input() btnOkClass: string = 'btn-success';
	@Input() btnCloseDisplay: boolean = true;
	@Input() isBtnOkActive: boolean = true;
	@Input() form: BaseFormGroup;
	
	@Input() isLoading: boolean = false;
	
	@Output() onOk = new EventEmitter<any>();
	
	constructor(public activeModal: NgbActiveModal){
	
	}
	
	ngOnInit() {
		if (this.form) {
			this.form.statusChanges.subscribe(status => this.isBtnOkActive = status === 'VALID');
			this.form.$beforeSubmit.subscribe(() => console.log('base modal ngOnInit subscribe'))
		}
	}
	
	ok() {
		const me = this;
		
		me.onOk.emit();
		
		if (me.form && me.form.status === 'VALID') {
			me.isLoading = true;
			
			me.form.$beforeSubmit.next(function (err) {
				me.isLoading = false;
				
				if (err) {
					me.form.sendFormError = err;
					
					return ;
				}
				
				me.form.sendFormError = null;
				
				// Оставляем для обратной совместимости
				me.activeModal.close(
					me.form.value
				);
			});
			
			return;
		}
	}
	
	close() {
		this.activeModal.close('cancel');
	}
}


class NgbModalRefObservable extends NgbModalRef {
	public o$: Observable<Object>;
	
	public $beforeSubmit: Subject<Function>;
}


@Injectable()
export class ModalService {
	constructor(private modalService: NgbModal) {}
	
	open(content: any, data?: any, options?: any): NgbModalRefObservable {
		options = Object.assign({backdrop: 'static', size: 'md'}, options || {});
		
		const modalRef = <NgbModalRefObservable>this.modalService.open(content, options);
		
		modalRef['o$'] = Observable.create(observer => {
			modalRef.result.then(
				(value) => {
					observer.next(value);
					observer.complete();
				},
				(err) => {
					console.log('result err', err)
					observer.error(err);
				}
			);
		});
		
		if (modalRef.componentInstance.form) {
			modalRef['$beforeSubmit'] = modalRef.componentInstance.$beforeSubmit;
		}
		
		if (data) {
			const keys = Object.keys(data);
			for (let i = 0, length = keys.length; i < length; i++) {
				const key = keys[i];
				modalRef.componentInstance[key] = data[key];
			}
		}
		
		
		return modalRef;
	}
	
	openEmpty(content: any, options?: any) {
		options = Object.assign({backdrop: 'static', size: 'md'}, options || {});
		const modalRef = this.modalService.open(content, options);
		
		modalRef.componentInstance['title'] = 'Loading...';
		modalRef.componentInstance['isLoading'] = true;
		
		return modalRef;
	}
	
	fillData(modalRef: NgbModalRef, data: any) {
		let keys = Object.keys(data);
		for (let i = 0, length = keys.length; i < length; i++) {
			let key = keys[i];
			modalRef.componentInstance[key] = data[key];
		}
		
		modalRef.componentInstance['isLoading'] = false;
		
		return modalRef;
	}
}


export function RestoreChild<ClassT, T>(): any {
	return (target: Object, propertyKey: string | symbol) => {
		var descriptor = Object.getOwnPropertyDescriptor(target, propertyKey) || {configurable: true, enumerable: true};
		
		var value: T;
		var originalGet = descriptor.get || (() => value);
		var originalSet = descriptor.set || (val => value = val);
		
		descriptor.get = originalGet;
		descriptor.set = originalSet;
		
		Object.defineProperty(target, propertyKey, descriptor);
		return descriptor;
	}
}
